import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { NavLink } from "react-router-dom";

interface BreadcrumbsProps {
  crumbs: Array<{
    name: string;
    path: string;
  }>;
  className?: string;
}
export default function Breadcrumbs({ crumbs, className }: BreadcrumbsProps) {
  if (!crumbs || crumbs.length <= 0) {
    return null;
  }

  return (
    <div className="w-100">
      <Breadcrumb className={className}>
        {crumbs.map(({ name, path }, key) =>
          key + 1 === crumbs.length ? (
            <BreadcrumbItem key={name + key + 1} active>
              {name}
            </BreadcrumbItem>
          ) : (
            <BreadcrumbItem key={name + key}>
              <NavLink to={path}>{name}</NavLink>
            </BreadcrumbItem>
          )
        )}
      </Breadcrumb>
    </div>
  );
}
